import { render, staticRenderFns } from "./contact-us-page.vue?vue&type=template&id=379fc877&scoped=true&"
import script from "./contact-us-page.vue?vue&type=script&lang=js&"
export * from "./contact-us-page.vue?vue&type=script&lang=js&"
import style0 from "./contact-us-page.vue?vue&type=style&index=0&id=379fc877&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379fc877",
  null
  
)

export default component.exports